import { render, staticRenderFns } from "./classifieds.vue?vue&type=template&id=0ada92f4&scoped=true&lang=pug"
import script from "./classifieds.vue?vue&type=script&lang=ts"
export * from "./classifieds.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ada92f4",
  null
  
)

export default component.exports